import moment from "moment";
import { useAuthSelector } from "@risalabs_frontend_org/auth-wrapper";
import { useSelector } from "react-redux";
import { DateInput } from "risa-oasis-ui_v2";
import { usePayerNameContextFromSingleOrderLayout } from "../../context/payerNameContextFromSingleOrderLayout";
import { usePharmaFormFields } from "../../context/pharmaFormFieldsContext";
import { DateField } from "../../data-model/pharmaPaFormModel";
import { ScreenNamesForBigQuery } from "../../../shared/enums/eventsData";
import { EventsName } from "../../../shared/enums/eventsName";
import { checkIfErrorExists } from "../../pages/pharmaPaForm/utils/checkIfErrorExists";
import { RootState } from "../../redux/store/store";
import { getNestedValue } from "../../utils/getNestedValue";
import { getOrgIdForFetchExternalWorklist } from "../../utils/organizationHelper";

import { apiWorkerManager } from "../../workerManagers/workerManager";
interface DateFieldProps {
  field: DateField;
  fieldDetails?: Record<string, any>;
  data?: any;
  originalData?: any;
  shouldEmitLogEvent?: boolean;
}

const RenderDateField = (props: DateFieldProps) => {
  const { formFieldsData, setFormFieldsData } = usePharmaFormFields();

  const { user } = useAuthSelector((state) => state.firebaseAuthentication,
  );

  const { data: singleMedicalPaFormConfig } = useSelector(
    (state: RootState) => state.singleMedicalPaFormConfig,
  );
  const { payerName } = usePayerNameContextFromSingleOrderLayout();

  const initialDataValue = getNestedValue(props?.data, props.field.key) ?? "";

  const computeDefaultDateValue = () => {
    if (props?.field?.readOnly) {
      return formFieldsData?.[props?.field?.key]?.filledValue ?? "";
    }
    if (initialDataValue && initialDataValue !== "") {
      return initialDataValue;
    } else {
      return props?.field?.default || "";
    }
  };
  const handleDateFieldOnChange = (data) => {
    const originalDataValue =
      getNestedValue(props?.originalData, props.field.key) ?? "";
    const isFieldDirty = data.value !== originalDataValue;
    setFormFieldsData({
      ...formFieldsData,
      [props?.field?.key]: {
        ...formFieldsData[props?.field?.key],
        filledValue: data.value !== "" ? data.value : "",
        isFieldDirty,
      },
    });

    if (props?.shouldEmitLogEvent) {
      apiWorkerManager.enqueueAndProcess({
        patient_id: props?.originalData?.patient_id,
        order_id: props?.originalData?.order_id,
        org_id: getOrgIdForFetchExternalWorklist(),
        user_id: user?.id ?? "",
        user_email: user?.email ?? "",
        event_name:
          EventsName.FORM_FIELD_EDITED + " (" + props?.field?.label + ")",
        additional_data: {
          field_key: props?.field?.key,
          new_value: data.value,
          old_value: getNestedValue(props?.originalData, props.field.key) ?? "",
          form_id: singleMedicalPaFormConfig?.id ?? "",
          screen_name: ScreenNamesForBigQuery.FORM_SCREEN,
          field_name: props?.field?.label ?? "",
          payer_name: payerName,
        },
      });
    }
  };

  return (
    <>
      <div
        key={props?.field?.key}
        className={`date-field__container flex-1`}
        style={{
          maxWidth: props?.field?.width ? `${props.field.width}%` : "100%",
        }}
      >
        <DateInput
          id={props?.field?.key}
          label={props?.field?.label}
          defaultValue={
            computeDefaultDateValue()
              ? moment(computeDefaultDateValue()).format("MM/DD/YYYY")
              : ""
          }
          required={props?.field?.isRequired}
          format={"MM/DD/YYYY"}
          error={
            checkIfErrorExists(
              formFieldsData,
              props.field.key,
              props?.field?.readOnly,
            )
              ? `${props?.field?.validationMessage ?? "This field is required"}`
              : ""
          }
          onChange={(data) =>
            handleDateFieldOnChange({
              ...data,
              value: moment(data.value).format("MM/DD/YYYY"),
            })
          }
        />
        {(props?.field?.additionalInfoHeader ||
          props?.field?.additionalInfoContent) && (
          <div className="section-additonal-info flex w-full flex-col gap-2 bg-secondaryYellow-11 p-3">
            <div className="section-additonal-info__header text-tiny font-bold">
              {props?.field?.additionalInfoHeader ?? ""}
            </div>
            <div className="section-additonal-info__content text-[0.8125rem] font-normal">
              {props?.field?.additionalInfoContent ?? ""}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RenderDateField;
